<template>
    <div class="main-window-l w-1200">
        <div class="step-nav">
            <div class="nav-item active">
                样片观摩——排片
            </div>
        </div>

        <div class="film-box film-list">
            <div v-for="item in listData" :key="item.id" class="item" @click="toDetail(item.id)">
                <img :src="srcComputed(item.filmAttachment)" />
                <div class="intro">
                    <p>{{ item.filmName }}</p>
                    <p>{{ item.filmDuration }}</p>
                    <p>{{ item.filmPlace }}</p>
                </div>
            </div>
        </div>
        <div class="foo foo-center">
            <button class="leftBtn" @click="goBack">返回</button>
        </div>
    </div>
</template>

<script>
import { getFilmList } from '@/api/industryScreen';
import { sessionData } from "@/static/js/local.js";

export default {
    data() {
        return {
            listData: []
        }
    },
    created() {
        let detailForm = sessionData("get", "UserInfo");
        let isInvestor = detailForm.details.some(item => item.guestType == "10" && item.verifyFlag == 1);

        if (!isInvestor) {
            this.$msgbox({
                title: "提示",
                message: "您还不是一对一洽谈创投嘉宾，请先报名成为创投嘉宾再进行预约",
                showClose: false,
                confirmButtonClass: "btn-color",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                callback: (action, instance) => {
                    if (action == "confirm") {
                        this.$router.push("/1v1/vc");
                    }
                }
            });
            return;
        }

        this.getList();
    },
    computed: {
        srcComputed() {
            return function(id) {
                let imgSrc = '';
                if(id && id !== '') {
                    imgSrc = process.env.VUE_APP_IMG_BASE_URL + id;
                }
                return imgSrc
            }
        }
    },
    methods: {
        getList() {
            getFilmList({
                mainId: this.$session.get("cmm").mainId
            }).then(res => {
                if (res && res.code === 200) {
                    this.listData = res.data;
                }
            });
        },
        toDetail(id) {
            this.$router.push({
                path: '/1v1/industry_screen_detail',
                query: {
                    id
                }
            });
        },
        goBack() {
            this.$router.push({
                name: 'industryScreenAppoint'
            });
        }
    }
}
</script>

<style src="../../static/css/regist.css" scoped></style>
<style src="../../static/css/infoCommon.css" scoped></style>
<style src="../../static/css/film.css" scoped></style>
